import React, { useEffect, useState } from 'react'

import Search from 'components/Search'

import Api from 'services/api'
import styled from 'styled-components'
import { NavLink } from 'react-router-dom'

type Props = {
  onSuccessfulSearch: (arg1) => void
  className?: string
  loadedVideoName?: string
}

const WistiaVideoFields = ({ onSuccessfulSearch, className, loadedVideoName = '' }: Props) => {
  const [value, setValue] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [loadedVideo, setLoadedVideo] = useState<string>('')
  const [showSpinner, setShowSpinner] = useState(false)

  const onSearch = (searchTerm = '') => {
    setShowSpinner(true)

    Api.WistiaVideo.get(searchTerm)
      .then((response) => {
        setLoadedVideo('video')
        onSuccessfulSearch(response)
        setShowSpinner(false)
      })
      .catch(() => {
        setErrorMessage(`Video ID ${searchTerm} not found`)
        setShowSpinner(false)
      })
  }

  useEffect(() => {
    setLoadedVideo(loadedVideoName)
  }, [loadedVideoName])

  return (
    <S.Section>
      <S.SearchContainer hide={(loadedVideo !== '')}>
        <Search
          variant="text"
          value={value}
          onChange={(newSearchTerm) => { setValue(newSearchTerm) }}
          onSearch={onSearch}
          onClickClearIcon={() => { setValue(''); setErrorMessage(''); setShowSpinner(false) }}
          placeholder="Search by video ID"
          ariaLabel="Search wistia videos"
          errorMessage={errorMessage}
          className={className}
          showSpinner={showSpinner}
        />
      </S.SearchContainer>

      {loadedVideo !== '' && (
        <S.RemoveVideo>
          <NavLink to="#" onClick={(e:React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
            e.preventDefault()
            setLoadedVideo('')
          }}
          >Edit Video
          </NavLink>
        </S.RemoveVideo>
      )}
    </S.Section>
  )
}

export default WistiaVideoFields

const S = {
  RemoveVideo: styled.div`
    display: flex;
    flex-direction: column;
    max-width: 750px;
  `,
  SearchContainer: styled.div.withConfig({
    shouldForwardProp: (prop) => !['hide'].includes(prop)
  })<{ hide: boolean }>`
    ${({ hide }) => hide && `
      display: none;
    `}
  `,
  Section: styled.div`
    width: fit-content;
    min-width: 250px;
  `
}
